<dx-popup
    #boardApprovalGridNotesPopup
    minWidth="150px"
    minHeight="150px"
    width="30%"
    height="50%"
    title="Notes For: {{ popupTitle }}"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onNotesPopClose()"
>
    <div *dxTemplate="let data of 'content'">
        <app-notes-editor
            #boardApprovalNotes
            [allowNewNotes]="allowNewNotes"
            [previousNotes]="previousNotes"
            [previousNotesVisible]="true"
            (onNotesPopUpClose)="onNotesPopClose()"
            (onNewNotesSave)="onSaveNotes($event)"
        ></app-notes-editor>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#boardApprovalGridNotesPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
